import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import * as d3 from "d3";
import { useSelector } from "react-redux";

import Rating from "../components/Rating";
import Reviews from "../components/UserReviews";
import { USER_ORDER_N_EARNING_URL } from "../utils/api-ends";
import useHttp from "../hooks/useHttp";

gsap.registerPlugin(ScrollTrigger);

const UserRating = () => {
  const rating_ref = useRef(null);
  const [anim_rating, setAnim_rating] = useState(false);
  const [fiveStarAvag, setFiveStarAvag] = useState("");
  const [fourStarAvag, setFourStarAvag] = useState("");
  const [threeStarAvag, setThreeStarAvag] = useState("");
  const [twoStarAvag, setTwoStarAvag] = useState("");
  const [oneStarAvag, setOneStarAvag] = useState("");
  const [userRelatedData, setUserRelatedData] = useState({});
  const { sendRequests } = useHttp();
  const userData = useSelector((state) => state.basicInfo?.userDetails);

  useEffect(() => {
    const response = (data) => {
      setUserRelatedData(data);
    };

    // Send request to get profile info
    sendRequests(
      {
        url: USER_ORDER_N_EARNING_URL(userData?.id),
        method: "GET",
      },
      response
    );
  }, [userData?.id, sendRequests]);

  useEffect(() => {
    setFiveStarAvag(
      (userRelatedData.rating_related_statistics?.total_five_star_rating /
        userRelatedData.rating_related_statistics?.total_rating) *
        100 +
        "%"
    );
    setFourStarAvag(
      (userRelatedData.rating_related_statistics?.total_four_star_rating /
        userRelatedData.rating_related_statistics?.total_rating) *
        100 +
        "%"
    );
    setThreeStarAvag(
      (userRelatedData.rating_related_statistics?.total_three_star_rating /
        userRelatedData.rating_related_statistics?.total_rating) *
        100 +
        "%"
    );
    setTwoStarAvag(
      (userRelatedData.rating_related_statistics?.total_two_star_rating /
        userRelatedData.rating_related_statistics?.total_rating) *
        100 +
        "%"
    );
    setOneStarAvag(
      (userRelatedData.rating_related_statistics?.total_one_star_rating /
        userRelatedData.rating_related_statistics?.total_rating) *
        100 +
        "%"
    );
  }, [userRelatedData.rating_related_statistics]);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: rating_ref.current,
      start: "bottom bottom",
      endTrigger: rating_ref.current,
      end: "bottom bottom",
      markers: false,
      onEnter: () => setAnim_rating(true),
    });
  }, [rating_ref]);

  useEffect(() => {
    // https://www.pluralsight.com/guides/using-d3.js-inside-a-react-app
    /**
            Ata apadoto amra static vabe kora raklam, eid er pora satu uporer link othoba google theka dekha,
            d3 abong custom hook use kora dynamicly korba. Insha-Allah
    **/

    var endPercent =
      userRelatedData.rating_related_statistics?.rating_average / 5;

    var radius = 80;
    var color = "#006994";
    var border = 5;
    var startPercent = 0;

    var twoPi = Math.PI * 2;
    var boxSize = 160;

    var count = Math.abs((endPercent - startPercent) / 0.01);
    var step = endPercent < startPercent ? -0.01 : 0.01;

    var arc = d3.svg
      .arc()
      .startAngle(0)
      .innerRadius(radius)
      .outerRadius(radius - border);

    if (
      document.querySelector(".svg-cls") &&
      document.querySelector(".svg-cls").style
    ) {
      document.querySelector(".svg-cls").style.display = "none";
    }

    var parent = d3.select("#rating-progress");

    var svg = parent
      .append("svg")
      .attr("width", boxSize)
      .attr("height", boxSize)
      .attr("class", "svg-cls");

    var g = svg
      .append("g")
      .attr("transform", "translate(" + boxSize / 2 + "," + boxSize / 2 + ")");

    var meter = g.append("g").attr("class", "progress-meter");

    meter
      .append("path")
      .attr("class", "background")
      .attr("fill", "#D9E9EF")
      .attr("fill-opacity", 0.5)
      .attr("d", arc.endAngle(twoPi));

    var front = meter
      .append("path")
      .attr("class", "foreground")
      .attr("fill", color)
      .attr("fill-opacity", 1);

    function updateProgress(progress) {
      front.attr("d", arc.endAngle(twoPi * progress));
    }

    var progress = startPercent;
    function loops() {
      updateProgress(progress);

      if (count > 0) {
        count--;
        progress += step;
        setTimeout(loops, 10);
      }
    }

    loops();
  }, [userRelatedData.rating_related_statistics?.rating_average]);

  return (
    <>
    <div className="container" style={{'padding':'0px'}}>
      <div className="theme-section">
        <h1 className="section-tittle">
          Total Rating (
          {userRelatedData.rating_related_statistics?.total_rating})
        </h1>

        <div className="rating-details-info add-pendding-left" ref={rating_ref}>
          <div id="rating-progress">
            <div className="rating-progress-details">
              <span>
                {userRelatedData.rating_related_statistics?.rating_average}
              </span>
              <div className="rating-star">
                {!["", null, undefined].includes(
                  userRelatedData.rating_related_statistics?.rating_average
                ) && (
                  <Rating
                    rating={
                      userRelatedData.rating_related_statistics?.rating_average
                    }
                  />
                )}
              </div>
            </div>
          </div>

          <div className="rating-details-box">
            <div className="rating-number-with-progess-bar">
              <span>5 Star</span>
              <div className="state-line-progess-bar">
                <div
                  style={{ width: fiveStarAvag }}
                  className="state-line-current-progess"
                ></div>
              </div>
              <span>
                {
                  userRelatedData.rating_related_statistics
                    ?.total_five_star_rating
                }
              </span>
            </div>
            <div className="rating-number-with-progess-bar">
              <span>4 Star</span>
              <div className="state-line-progess-bar">
                <div
                  style={{ width: fourStarAvag }}
                  className="state-line-current-progess"
                ></div>
              </div>
              <span>
                {
                  userRelatedData.rating_related_statistics
                    ?.total_four_star_rating
                }
              </span>
            </div>
            <div className="rating-number-with-progess-bar">
              <span>3 Star</span>
              <div className="state-line-progess-bar">
                <div
                  style={{ width: threeStarAvag }}
                  className="state-line-current-progess"
                ></div>
              </div>
              <span>
                {
                  userRelatedData.rating_related_statistics
                    ?.total_three_star_rating
                }
              </span>
            </div>
            <div className="rating-number-with-progess-bar">
              <span>2 Star</span>
              <div className="state-line-progess-bar">
                <div
                  style={{ width: twoStarAvag }}
                  className="state-line-current-progess"
                ></div>
              </div>
              <span>
                {
                  userRelatedData.rating_related_statistics
                    ?.total_two_star_rating
                }
              </span>
            </div>
            <div className="rating-number-with-progess-bar">
              <span>1 Star</span>
              <div className="state-line-progess-bar">
                <div
                  style={{ width: oneStarAvag }}
                  className="state-line-current-progess"
                ></div>
              </div>
              <span>
                {
                  userRelatedData.rating_related_statistics
                    ?.total_one_star_rating
                }
              </span>
            </div>
          </div>
        </div>

        <Reviews userId={userData?.id} />

        
      </div>
    </div>


    

    </>
  );
};

export default UserRating;
